import * as React from 'react'
import {connect} from 'react-redux'
import * as RasaInput from '../../components/rasa-input'
import * as Actions from './actions'
import * as Types from './types'

interface DispatchProps { onChange: Types.SelectDateActionCreator }
type Props = Types.WrappedContentCalendarState & DispatchProps

export const DateFilter = connect(
  ({contentCalendar}: Types.WrappedContentCalendarState) => ({contentCalendar}),
  {onChange: Actions.updateSelectedDate},
)(({contentCalendar, onChange}: Props) =>
  <RasaInput.RasaDatePicker onChange={onChange} value={contentCalendar.data.selectedDate} />)



// WEBPACK FOOTER //
// ./src/pages/content-calendar/date-filter.tsx